import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '/features' },
    { label: 'How It Works', href: '/#how-it-works' },
    { label: 'Pricing', href: '/#pricing' },
    { label: 'Blog', href: '/blog' },
  ];

  return (
    <>
      {/* Top accent bar */}
      <div className="fixed top-0 left-0 right-0 z-50 h-[3px] bg-gradient-to-r from-teal-400 via-emerald-400 to-teal-500" />

      <header
        className={`fixed top-[3px] left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white border-b border-teal-100 shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-7 h-7 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-md flex items-center justify-center">
              <i className="ri-plane-line text-white text-sm" />
            </div>
            <span className="text-lg font-semibold text-gray-900 tracking-tight">
              Tre<span className="bg-gradient-to-r from-teal-500 to-emerald-500 bg-clip-text text-transparent">Waz</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              link.href.startsWith('/') && !link.href.startsWith('/#') ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              )
            ))}
          </nav>

          {/* Desktop Right */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/login"
              className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="text-sm font-medium bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-4 py-2 rounded-md hover:from-teal-600 hover:to-emerald-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Start Free Trial
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-gray-700`} />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-teal-50 px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              link.href.startsWith('/') && !link.href.startsWith('/#') ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-gray-700 hover:text-teal-600 cursor-pointer"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </a>
              )
            ))}
            <div className="flex flex-col gap-2 pt-2 border-t border-gray-100">
              <Link to="/login" className="text-sm text-gray-600 cursor-pointer">Login</Link>
              <Link
                to="/register"
                className="text-sm font-medium bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-4 py-2 rounded-md text-center cursor-pointer whitespace-nowrap"
              >
                Start Free Trial
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
